<template>
    <td v-if="value.Working" :class="[color,{'not-saved':!value.Saved && value.Editable}]" class="text-center">
        <template v-if="value.Editable">
            <template v-if="loading">
                <b-spinner small></b-spinner>
            </template>
            <template v-else>
                <div class="position-relative">
                    <div class="bg-dark text-white lock-box position-absolute" v-if="value.Locked">
                        <feather-icon icon="LockIcon" size="10" ></feather-icon>
                    </div>
                    <select class="daily-select" :disabled="onMultiple || value.Locked" v-model="newCode" v-on:change="$emit('change',$event.target.value)">
                        <option :value="null" v-if="newCode == null">?</option>
                        <option v-for="(t,i) in c_types" :key="i" :value="t.Id">{{t.Code}}</option>
                    </select>
                </div>
            </template>
        </template>
        <template v-else>
            {{code || "-"}}
        </template>
    </td>
    <td v-else class="bg-light"></td>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
    components:{
        BSpinner
    },
    props:{
        loading:Boolean,
        value:Object,
        onMultiple:Boolean,
        allTypes:{
            type:Array,
            default:()=>([])
        },
        typesWithoutExcuse:{
            type:Array,
            default:()=>([])
        },
    },
    data(){
        return {
            newCode:this.value.EmployeeWorkingTypeId || null
        }
    },
    watch:{
        "value.EmployeeWorkingTypeId"(old,nw){
            if(old != nw) {
                this.newCode = this.value.EmployeeWorkingTypeId
            }
        }
    },
    computed:{
        code(){
            let type = this.types.find(t=> t.Id == this.newCode)
            return type?.Code || null
        },
        color(){
            let type = this.types.find(t=> t.Id == this.newCode)
            return 'type-' + type?.Color || null
        },
        types(){
            let typeList = []
            if(!this.typesWithoutExcuse.map(s => s.Id).includes(this.value.EmployeeWorkingTypeId)) typeList = [
                ...this.typesWithoutExcuse,
                this.allTypes.find(t => t.Id == this.value.EmployeeWorkingTypeId) || null
            ]
            else typeList = this.typesWithoutExcuse
            // if(this.value.Excuse?.EmployeeExcuseType.EmployeeWorkingType?.Id){
            //     const ex = this.allTypes.find(e => e.Id = this.value.Excuse?.EmployeeExcuseType.EmployeeWorkingType?.Id)
            //     if(ex) typeList.push(ex)
            // }
            return typeList
        },
        c_types(){
            if(this.types){
                if(this.value.Excuse){
                    return this.types.filter(t => t.Id == this.value.Excuse?.EmployeeExcuseType.EmployeeWorkingType?.Id)
                }else return this.types
            }else return []
        }
    }
}
</script>

<style>
.not-saved{
    box-shadow: inset 0px 0px 0px 2px rgb(255, 36, 66,0.5);
    background-color: rgb(255, 36, 66,0.375);
}

.not-saved .daily-select{
    border-color: rgb(255, 36, 66, 1);
    color: rgb(255, 36, 66, 1);
}

.daily-select{
    font-family: 'Arial';
    display: inline-block;
    width: 100%;
    cursor: pointer;
    padding: 0;
    outline: 0;
    border: 2px solid #000000;
    border-radius: 0.375rem;
    background: #ffffff;
    color: #000000;
    appearance: none;
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: none;
}
.daily-select::-ms-expand {
    display: none;
}
.daily-select:hover,
.daily-select:focus {
    color: #000000;
    background: #ffffff;
}
.daily-select:disabled {
    opacity: 0.3;
    pointer-events: none;
}
.lock-box{
    padding: 0.25rem;
    aspect-ratio: 1;
    font-size: 0.25rem;
    z-index: 1;
    top: -4px;
    right: -6px;
    border-radius: 1rem;
}

</style>